<template>
  <van-popup
    class="ai-mobile-delete-popup"
    :close-on-click-overlay="!loading"
    :show="show"
    teleport="body"
    @update:show="emit('update:show', $event)"
  >
    <section :aria-labelledby="titleId" aria-modal="true" class="ai-mobile-delete" role="dialog">
      <div class="ai-mobile-delete__content">
        <h2 :id="titleId">{{ title }}</h2>
        <p>{{ message }}</p>
      </div>
      <div class="ai-mobile-delete__footer">
        <button :disabled="loading" type="button" @click="emit('update:show', false)">取消</button>
        <button
          class="ai-mobile-delete__confirm"
          :disabled="loading"
          type="button"
          @click="emit('confirm')"
        >
          <van-loading v-if="loading" color="#ff5a65" size="18px" />
          <span v-else>删除</span>
        </button>
      </div>
    </section>
  </van-popup>
</template>

<script setup>
import { useId } from 'vue'
import { Loading as VanLoading, Popup as VanPopup } from 'vant'

defineProps({
  show: Boolean,
  loading: Boolean,
  title: { type: String, default: '确认删除' },
  message: { type: String, default: '删除后将无法恢复，确定删除吗？' }
})
const emit = defineEmits(['update:show', 'confirm'])
const titleId = useId()
</script>

<style lang="scss" scoped>
.ai-mobile-delete-popup {
  width: min(311px, calc(100vw - 48px));
  overflow: hidden;
  border-radius: 16px;
}
.ai-mobile-delete {
  color: #323233;
  background: #fff;
  text-align: center;

  &__content {
    padding: 24px;
    h2 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
    }
    p {
      margin: 8px 0 0;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.14px;
    }
  }
  &__footer {
    display: flex;
    border-top: 0.5px solid #e5e6eb;
    button {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      height: 48px;
      padding: 0 12px;
      border: 0;
      background: #fff;
      color: #646566;
      font-size: 16px;
      line-height: 22px;
      & + button {
        border-left: 0.5px solid #e5e6eb;
      }
    }
    .ai-mobile-delete__confirm {
      color: #ff5a65;
    }
  }
}
</style>
